<template>
  <label
    :class="[
      'checkbox-btn',
      `checkbox-btn--${color}`,
      { 'checkbox-btn--checked': isChecked, disabled: disabled },
    ]"
  >
    <input
      type="checkbox"
      :id="id"
      class="checkbox-btn__input"
      v-model="isChecked"
      :disabled="disabled"
    />
    <span class="checkbox-btn__label">
      <slot />
    </span>
  </label>
</template>

<script setup lang="ts">
type CheckboxButtonProps = {
  id?: string;
  color?: "white";
  disabled?: boolean;
};

const { color = "white" } = defineProps<CheckboxButtonProps>();

const isChecked = defineModel<boolean>("checked", { default: false });
</script>

<style lang="scss" scoped>
.checkbox-btn {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid transparent;

  &--white,
  &.disabled {
    background-color: white;
    color: var(--clr-p9);
    box-shadow: var(--shd-tag);
  }
  &--checked {
    background-color: var(--clr-p1) !important;
    color: var(--clr-n8);
    border: 1px solid var(--clr-p5);
    box-shadow: var(--shd-tag);
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:not(.disabled) {
    &:hover {
      background-color: var(--clr-p1);
      color: var(--clr-p9);
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.16);
      cursor: pointer;
    }
    &:active {
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16) inset;
    }
  }
  &__input {
    display: none; /** hide the checkbox */
  }

  &__label {
    display: flex;
    align-items: center;
  }
}
</style>
